<template>
  <div>
    <b-button variant="outline-secondary" size="sm" class="ml-2" @click="() => (isModalOpen = true)">
      {{ $t("Seus próximos passos") }}
    </b-button>
    <b-modal v-model="isModalOpen" id="modal-next-graduation" :title="$i18n.t('Próxima Graduação')" centered hide-footer
      no-close-on-backdrop>

      <div class="text-left mb-3 mt-2">
        <h4>{{ $t('Próxima graduação:') }} <span class="text-primary">{{ getNextGraduationInfo.type }}</span></h4>
      </div>

      <div class="timeline-container">
        <div v-for="(item, index) in getNextGraduationInfo.timeline" :key="index" class="timeline-item"
          :class="{ 'completed': item.value, 'pending': !item.value }">
          <div class="timeline-marker">
            <i class="fas" :class="item.value ? 'fa-check' : 'fa-times'"></i>
          </div>
          <div class="timeline-content">
            <h5 :class="{ 'text-success': item.value, 'text-secondary': !item.value }">
              {{ item.label[$i18n.locale] || item.label.en }}
            </h5>
            <p v-if="!item.value && item.info" class="text-muted small">
              {{ item.info[$i18n.locale] || item.info.en }}
            </p>
            <p v-else class="text-muted small">
              {{ item.value ? $t("Sim") : $tc("Não") }}
            </p>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { BModal, BButton, VBModal } from "bootstrap-vue";
export default {
  components: {
    BModal, BButton, VBModal
  },
  data() {
    return {
      isModalOpen: false,
    };
  },
  props: {
    getNextGraduationInfo: {
      type: Object,
      default: () => { },
    },
  },
};
</script>

<style scoped>
.timeline-container {
  position: relative;
  padding: 0 0 0 1rem;
  margin: 0 0 0 1rem;
  border-left: 2px solid rgba(255, 255, 255, 0.2);
}

.timeline-item {
  position: relative;
  padding: 0 0 1rem 1.5rem;
  margin-left: -1rem;
}

.timeline-marker {
  position: absolute;
  left: -0.85rem;
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.completed .timeline-marker {
  background-color: #28a745;
  color: white;
}

.pending .timeline-marker {
  background-color: #6c757d;
  color: white;
}

.timeline-content {
  padding: 0.5rem 0;
}

.text-muted.small {
  margin-bottom: 0;
  margin-top: -8px;
}
</style>
